import React, { useEffect, useState } from 'react';

const MarkAllAsBillableToggleSwitchV2 = (props) => {
  const { timeEntires, setTimeEntries, setTimeEntriesError } = props || {};
  const [allBillable, setAllBillable] = useState(false);

  useEffect(() => {
    const allTrue = timeEntires?.length > 0 && timeEntires?.every((entry) => entry?.billable === true);
    setAllBillable(allTrue);
  }, [timeEntires]);

  return (
    <>
      <div className="d-flex align-items-center">
        <span className="caption-bold mb-0 pe-4">Mark all as Billable</span>
        <label className="switch">
          <input
            type="checkbox"
            name="non_billable"
            checked={allBillable}
            onChange={(e) => {
              let billable = true;

              if (!e.target.checked) {
                billable = false;
                setTimeEntriesError({});
              }

              setTimeEntries(
                timeEntires.map((ele) => ({
                  ...ele,
                  billable,
                }))
              );
            }}
          />{' '}
          <span className="slider round"></span>
        </label>
      </div>
    </>
  );
};

export default MarkAllAsBillableToggleSwitchV2;
